// extracted by mini-css-extract-plugin
export default {"container":"SchemaCar_container__Eo9Gl","Main":"SchemaCar_Main__aQOe0"};